(function($)
{
    $.extend(true, orion, {
        api: {
            customerScalarAttribute: {}
        }
    });

    var
        api = orion.api.customerScalarAttribute,
        uri = '/api-customer-scalar-attribute';

    function read(name)
    {
        return $.ajax(uri + '/' + name, {
            method: 'GET'
        });
    }

    function update(name, value)
    {
        return $.ajax(uri + '/' + name + '/' + value, {
            cache: false,
            method: 'POST',
        });
    }

    api.read = read;
    api.update = update;
})(jQuery);
